<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { Picture as IconPicture } from "@element-plus/icons-vue";

import type { AvatarItem } from "../api/models";

const props = defineProps<{ items: Array<AvatarItem>; id: string }>();
const emit = defineEmits<{ (e: "update:id", value: string): void }>();
const imageUrl = ref<string>("");

const items = computed<Array<AvatarItem>>({
  get() {
    return props.items;
  },
  set() {}
});

const id = computed({
  get() {
    return props.id;
  },
  set(value) {
    emit('update:id', value);
    loadIcon(value);
  }
});

const loadIcon = (id: string) => {
  let found: boolean = false;
  for (let i = 0; i < items.value.length; ++i) {
    if (items.value[i].id === id) {
      imageUrl.value = items.value[i].imageUrl;
      found = true;
      break;
    }
  }

  if (!found) {
    imageUrl.value = "";
  }
}

watch(() => items, () => {
  loadIcon(id.value);
}, { deep: true });

</script>

<template>
  <el-select v-model="id" class="m-2" placeholder="选择微信账号" size="large" :clearable="true">
    <template #prefix>
      <el-image style="width: 26px; height: 26px; vertical-align: middle;" :src="imageUrl" fit="fill">
        <template #error>
          <div class="image-slot">
            <el-icon><icon-picture /></el-icon>
          </div>
        </template>
      </el-image>
    </template>
    <el-option v-for="item in items" :key="item.id" :label="item.name" :value="item.id" style="line-height: 30px;">
      <el-image style="width: 26px; height: 26px; vertical-align: middle;" :src="item.imageUrl" fit="fill" />
      <span style="padding-left: 10px;">{{ item.name }}</span>
    </el-option>
  </el-select>
</template>

<style scoped>
.image-slot .el-icon {
  font-size: 26px;
}
</style>
